import { Injectable,Injector } from '@angular/core';
import { HttpErrorResponse,HttpEvent,HttpHandler,HttpRequest,HttpInterceptor } from '@angular/common/http'
import { catchError,throwError,Observable, map } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private injector:Injector) { }

  intercept(req: HttpRequest<any>,next: HttpHandler):Observable<HttpEvent<any>>{

    let authServ = this.injector.get(AuthService);
    let tokenizedValue = req.clone({
      setHeaders:{
        Authorization:`Bearer ${authServ.getToken()}`,
      }
    })
    // return next.handle((tokenizedValue).pipe(catchError(this.errorMessage)));
    return next.handle(tokenizedValue);
  }

  errorMessage(error:HttpErrorResponse){
    return throwError(()=>new Error(error.message));
  }
}